import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, bindActionCreators } from 'redux';

import AddOnPlus from '../../components/AddOnPlus';

import withAuthGuard from '../withAuthGuard';
import withMembershipGuard from '../withMembershipGuard';
import withNoAvailableProducts from '../withNoAvailableProducts';

import { connectRequest } from '../../utils/query';
import { selectClient } from '../../global-selectors';
import { selectUserData } from '../../queries/selectors/user';
import { applyProductRules } from '../../queries/actions/rules';
import { getPaymentMethodRequest } from '../../queries/payment';
import withMembershipPurchased from '../withMembershipPurchased';
import { selectAllSubPaymentMethodsConfig, selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { addProduct, cleanOrder, setAddOnsToShow } from '../../queries/actions/shoppingCart';
import { setIgnoreRedirectInSubscription } from '../../queries/actions/subscriber';
import { getProductsToBuy, selectAddOnsToShow } from '../../queries/selectors/shoppingCart';
import { selectActivePlanSubscription, selectAvailableAddOns, selectProducts } from '../../queries/selectors/products';
import {
  selectSubscriptionsEntities,
  selectSubscriptionList,
  selectAddOnSubscriptions,
  selectSingleSubscriptionClient
} from '../../queries/selectors/bootstrap';
import { setCurrentSubPaymentMethod, setTotalPriceSummary } from '../../queries/actions/payment';
import { getSubPaymentMethodsByClient } from '../../queries/paymentMethods';

const mapStateToProps = (state) => {
  const userData = selectUserData(state);
  return {
    userPlan: selectActivePlanSubscription(state),
    client: selectClient(state),
    user: userData,
    methodId: selectCurrentPaymentMethod(state),
    addOnList: selectAvailableAddOns(state),
    subscriptions: selectSubscriptionsEntities(state),
    allSubscriptions: selectSubscriptionList(state),
    products: selectProducts(state),
    productsToBuy: getProductsToBuy(state),
    addOnsToShow: selectAddOnsToShow(state),
    addOnSubscriptions: selectAddOnSubscriptions(state),
    currentPaymentMethod: selectCurrentPaymentMethod(state),
    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    token: userData?.token,
    subPaymentMethods: selectAllSubPaymentMethodsConfig(state),
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addProduct: (data) => addProduct(data),
  applyProductRules: (data) => applyProductRules(data),
  setAddOnsToShow: payload => setAddOnsToShow(payload),
  setIgnoreRedirect: payload => setIgnoreRedirectInSubscription(payload),
  setTotalPriceSummary: payload => dispatch(setTotalPriceSummary(payload)),
  setCurrentSubPaymentMethod: payload => dispatch(setCurrentSubPaymentMethod(payload)),
  cleanOrder: () => cleanOrder(),
}, dispatch);

const mapPropsToConfigs = (props) => [
  getPaymentMethodRequest(props),
  getSubPaymentMethodsByClient(props)
];

export default compose(
  injectIntl,
  withMembershipGuard,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true }),
  connectRequest(mapPropsToConfigs),
  withNoAvailableProducts('addOn')
)(AddOnPlus);
